import axios from '@/libs/axios'

export default {
  getReports: () => axios.get('/report'),
  requestReport: data => axios.post('/report', data),
  downloadReport: id => axios.get(`/report/download/${id}`, {
    responseType: 'arraybuffer',
  }),
  getReportTypes: () => axios.get('/report/types'),
}
